import { ChangeDetectionStrategy, Component, inject, Inject } from '@angular/core';
import { StudentSummary } from '@app/core/models';
import { POPOVER_DATA, PopoverRef, SHARED_MODULES } from '@app/shared';
import { STUDENT_STATES } from './modal-review.component';

@Component({
  selector: 'app-modal-review-popover-filter-students',
  imports: [SHARED_MODULES],
  templateUrl: './modal-review-popover-filter-students.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalReviewPopoverFilterStudentsComponent {
  public popoverRef = inject(PopoverRef);
  public students: StudentSummary[] = inject(POPOVER_DATA);
  public groupedStudents: {
    corrected: StudentSummary[];
    completed: StudentSummary[];
    pending: StudentSummary[];
    all: StudentSummary[];
  };

  public selectedFilter: string;

  constructor() {
    this.groupedStudents = this.groupStudentsByState(this.students);
  }

  public onFilterSelected(filter: string, group) {
    this.selectedFilter = filter;
    this.popoverRef.close(group);
  }

  private groupStudentsByState(students: StudentSummary[]): any {
    const corrected = students.filter((student) => student.group_by === STUDENT_STATES.corrected);
    const completed = students.filter((student) => student.group_by === STUDENT_STATES.completed);
    const pending = students.filter((student) => student.group_by === STUDENT_STATES.pending);
    const all = students;
    return {
      corrected,
      completed,
      pending,
      all,
    };
  }
}
